// @todo revisit when we know more about how this all works

enum CheckoutStatus {
  CREATING_RECOGNITION = "creating_recognition",
  FAILED = "failed",
  ONGOING = "ongoing",
  PAYMENT_ERROR = "payment_error",
  PAYMENT_FORM_SUBMIT = "payment_form_submit",
  PAYMENT_FORM_VALIDATION_ERROR = "validation_error",
  SUCCESS = "success",
  UPDATING_RECOGNITION = "updating_recognition"
}

export default CheckoutStatus
